import { useState } from 'react';
import { UsersRepository } from '../../domain/repositories';
import { BankAccount, Loan, User } from '../../domain/models';
import { Alert } from '../../utils';
import { RestUsersRepository } from '../../infrastructure/repositories';
import { getUsersFilter } from '../../domain/repositories/UsersRepository';

const useUsers = () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<User[] | undefined>(undefined);
  const [userLoans, setUserLoans] = useState<Loan[] | undefined>(undefined);
  const [user, setUser] = useState<User | undefined>(undefined);
  const [bankAccount, setBankAccount] = useState<BankAccount | undefined>(undefined);
  const [totalPages, setTotalPages] = useState<number | undefined>(undefined);
  const [page, setPage] = useState<number | undefined>(undefined);
  const [filter, setFilter] = useState<getUsersFilter | undefined>(undefined);

  const usersRepository: UsersRepository = RestUsersRepository.getInstance();

  const loadUsers = async (
    page: number = 1,
    filter?: getUsersFilter
  ) => {
    setLoading(true);
    const [paginatedUsers, errorMessage] = await usersRepository.getUsers(
      page, filter
    );
    setLoading(false);

    if (errorMessage) {
      Alert.showError(errorMessage);
    } else {
      setUsers(paginatedUsers?.data);
      setTotalPages(paginatedUsers?.totalPages);
      setPage(paginatedUsers?.currentPage);
    }
  };

  const loadUser = async (userId: string) => {
    setLoading(true);
    const [user, errorMessage] = await usersRepository.getUser(userId);
    setLoading(false);

    if (errorMessage) {
      Alert.showError(errorMessage);
    } else {
      setUser(user);
    }
  }

  const loadUserBankAccount = async (userId: string) => {
    setLoading(true);
    const [bankAccount, errorMessage] = await usersRepository.getBankAccount(userId);
    setLoading(false);

    if (errorMessage) {
      Alert.showError(errorMessage);
    } else {
      setBankAccount(bankAccount);
    }
  }

  const loadUserLoans = async (
    userId: string,
    page: number = 1
  ) => {
    setLoading(true);
    const [paginatedLoans, errorMessage] = await usersRepository.getUserLoans(
      userId, page
    );

    if (errorMessage) {
      Alert.showError(errorMessage);
    } else {
      setUserLoans(paginatedLoans?.data);
      setTotalPages(paginatedLoans?.totalPages);
      setPage(paginatedLoans?.currentPage);
    }
    setLoading(false);
  };


  const clear = () => {
    setPage(undefined);
    setFilter(undefined);
  }

  return {
    totalPages,
    page,
    setPage,
    loadUsers,
    users,
    loading,
    filter,
    setFilter,
    clear,
    loadUser,
    user,
    setUser,
    loadUserBankAccount,
    bankAccount,
    setBankAccount,
    userLoans,
    setUserLoans,
    loadUserLoans
  };
};

export default useUsers;